import { get } from './client.js';

const ws = (wsId) => `/workspaces/${wsId}/analytics`;

export const getForecast     = (wsId) => get(`${ws(wsId)}/forecast`);
export const getIntelligence = (wsId) => get(`${ws(wsId)}/intelligence`);
